import { HeartPulseIcon } from './HeartPulseIcon';

/**
 * author: Google
 * id 389486F3-5A73-4C65-8EA6-43D432F6490E
 * name heart-pulse
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/heart-pulse.svg
 * tags
 * - Medical / Hospital 
 */
export const HeartVitalsIcon = HeartPulseIcon;
export default HeartVitalsIcon